
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_k2xwx_36",
  "slider": "awsui_slider_pcgz5_k2xwx_75",
  "slider-track": "awsui_slider-track_pcgz5_k2xwx_79",
  "slider-range": "awsui_slider-range_pcgz5_k2xwx_79",
  "disabled": "awsui_disabled_pcgz5_k2xwx_94",
  "readonly": "awsui_readonly_pcgz5_k2xwx_98",
  "error": "awsui_error_pcgz5_k2xwx_107",
  "warning": "awsui_warning_pcgz5_k2xwx_110",
  "active": "awsui_active_pcgz5_k2xwx_113",
  "error-active": "awsui_error-active_pcgz5_k2xwx_116",
  "warning-active": "awsui_warning-active_pcgz5_k2xwx_119",
  "labels": "awsui_labels_pcgz5_k2xwx_130",
  "labels-noref": "awsui_labels-noref_pcgz5_k2xwx_136",
  "labels-reference": "awsui_labels-reference_pcgz5_k2xwx_139",
  "labels-min": "awsui_labels-min_pcgz5_k2xwx_146",
  "labels-max": "awsui_labels-max_pcgz5_k2xwx_152",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_k2xwx_160",
  "ticks": "awsui_ticks_pcgz5_k2xwx_178",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_k2xwx_184",
  "tick": "awsui_tick_pcgz5_k2xwx_178",
  "middle": "awsui_middle_pcgz5_k2xwx_199",
  "filled": "awsui_filled_pcgz5_k2xwx_202",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_k2xwx_233",
  "thumb": "awsui_thumb_pcgz5_k2xwx_246",
  "min": "awsui_min_pcgz5_k2xwx_285",
  "max": "awsui_max_pcgz5_k2xwx_288"
};
  